import _ from 'underscore';
import { EventEmitter } from 'events';
import assign from 'object-assign';

const CHANGE_EVENT = 'change';

const AddressEventBus = assign({
  emitChange() {
    this.emit(CHANGE_EVENT, ...arguments);
  },
  bindListener(eventKey, callback) {
    this.on(eventKey, callback);
  },
  unbindListener(eventKey, callback) {
    this.removeListener(eventKey, callback);
  },
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },
}, EventEmitter.prototype);

export default AddressEventBus;


// WEBPACK FOOTER //
// ./src/pages/common/AddressEventBus.js